<template>
    <div>

        <div class="FrontPageLive"  v-if=" matchesATP.length > 0 || matchesWTA.length > 0 ">

            <div class="wrapper">

                <div class="score__head title-with-border">

                    <h2>Live Scores</h2>

                </div>

                <div class="grid two">
                    <div class="SC-results__column" >

                        <h3>
                            Men
                        </h3>

                        <score-live
                            v-if="matchesATP.length > 0"
                            type="atp"
                            :detail="detail"
                            :flag="flag">
                        </score-live>

                        <div class="na" v-else>
                            <h5 class="na__title" style="margin-bottom: 0">
                                Currently there are no live ATP matches
                            </h5>
                        </div>

                    </div>


                    <div class="SC-results__column" >

                        <h3>
                            Women
                        </h3>

                        <score-live
                            v-if="matchesWTA.length > 0"
                            type="wta"
                            :detail="detail"
                            :flag="flag">
                        </score-live>

                        <div class="na" v-else>
                            <h5 class="na__title" style="margin-bottom: 0">
                                Currently there are no live WTA matches
                            </h5>
                        </div>

                    </div>

                </div>



                <a class="general-button blue-background generic-medium" :href="centerlink">Go to Score Center</a>

            </div>

        </div>

        <div class="FrontPageOOP SC-OOP" v-if="today.length != '' ">

            <div class="wrapper">

                <div class="score__head title-with-border">

                    <h2>Order of Play</h2>

                </div>

                <score-oop-today-sc
                                :ticket="ticket"
                                :flag="flag"
                                :detail="detail"
                                :ooplink="ooplink">
                </score-oop-today-sc>

            </div>

        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import OOPTodaySC from './OOPTodaySC'
    import Live from './Live'
    import tz from 'moment-timezone'

    export default {
        props: ['ticket', 'flag', 'detail', 'ooplink', 'centerlink'],
        components: {
            'score-oop-today-sc'    : OOPTodaySC,
            'score-live'            : Live,
        },
        data() {
            return{
                oop           : [],
                today         : '',
                matchesATP: [],
                matchesWTA: [],
                feedATP: [],
                feedWTA: [],
            }
        },
        created() {
            this.getFeed()

            this.getLiveATP()
            this.getLiveWTA()

            let app = this
            setInterval(function () {
                app.getLiveATP()
                app.getLiveWTA()
            }, 15 * 1000, app)
        },
        methods: {
            getFeed() {
                return axios.get(`${window.feed_ip}/get/${window.tournament}/oop-mixed`).then(response => {

                    let oop = response.data

                    // switch to last day from feed after 8pm
                    let todayDate = moment().tz('America/New_York').startOf('day').format('YYYY-MM-DD')
                    let nowTime   = moment().tz('America/New_York').format('HH')
                    let usedDay   = ''

                    if ( nowTime >= 20 )
                        usedDay = response.data[response.data.length - 1].date
                    else
                        usedDay = todayDate

                    let today = oop.filter(function (day) {

                        //this needs to be uncommented afte we have a tournament
                        // return day.date == usedDay
                        return day.date
                    })

                    this.oop = response.data

                    if( !today[0] )
                        return;

                    today = today[0]

                    if (today.length == '0') {

                        let totalDaysCount = response.data.length
                        this.today = response.data[totalDaysCount - 1]

                        for ( let i = 0; i < response.data[totalDaysCount - 1].courts.length; i++ ) {
                            if ( response.data[totalDaysCount - 1].courts[i].matches.length >= 1 ) {
                                this.selectedCourt = response.data[totalDaysCount - 1].courts[i].id
                                break;
                            }
                        }

                    } else {
                        this.today = today

                        for ( let i = 0; i < today.courts.length; i++ ) {
                            if ( today.courts[i].matches.length >= 1 ) {
                                this.selectedCourt = today.courts[i].id
                                break;
                            }
                        }
                    }
                    // this.matches = this.getMatchesByCourt(this.selectedCourt)
                    //
                    // this.setupCourts()

                }).catch(function (error) {
                    console.log(error);
                });

            },
            getLiveATP() {

                let url = `${window.feed_ip}/get/atp/${window.tournament}/live`

                axios.get( url ).then( response => {

                    this.feedATP = response.data

                    let liveMatches = response.data

                    liveMatches.sort(function (a, b) {
                        return a.detail.crt - b.detail.crt
                    })

                    this.matchesATP = liveMatches


                }).catch( function ( error ) {
                    console.log( error )
                })

            },
            getLiveWTA() {

                let url = `${window.feed_ip}/get/wta/${window.tournament}/live`

                axios.get( url ).then( response => {

                    this.feedWTA = response.data

                    let liveMatches = response.data

                    liveMatches.sort(function (a, b) {
                        return a.detail.crt - b.detail.crt
                    })

                    this.matchesWTA = liveMatches

                }).catch( function ( error ) {
                    console.log( error )
                })

            }

        }
    }

</script>
